// @ts-nocheck

import { getPrivateIconUrl } from '../../../../config/urls';
import { BasketActionTypes } from '../../../../types/actions/basket';
import { MyMatchActionTypes } from '../../../../types/actions/mymatch';
import { pushOddsTravelAnimation } from '../../actions/oddsTravel';

export const handledActionTypes = [
  BasketActionTypes.ADD_ITEM,
  BasketActionTypes.IMPORT_ITEMS,
  MyMatchActionTypes.MERGE,
  MyMatchActionTypes.SPLIT,
];

const animationsMiddlewareHandler = ({ store: { dispatch }, action }: HandlerProps) => {
  const { type, payload = {} } = action;

  if (handledActionTypes.indexOf(type) !== -1) {
    if (
      type === BasketActionTypes.ADD_ITEM ||
      type === BasketActionTypes.IMPORT_ITEMS ||
      type === MyMatchActionTypes.MERGE ||
      type === MyMatchActionTypes.SPLIT
    ) {
      const { oddId, betslipReference, sourceElementUuid, isRepeatBet } = payload;

      const emoji = isRepeatBet ? getPrivateIconUrl('RECYCLING-SYMBOL') : undefined;

      if (sourceElementUuid) {
        dispatch(
          pushOddsTravelAnimation({
            oddId: oddId || betslipReference,
            sourceElementUuid,
            ts: Date.now(),
            emoji,
          }),
        );
      }
    }
  }
};

export default animationsMiddlewareHandler;
